<template>
    <div id="policy-container">

        <v-tabs
            v-model="tab"
            background-color="#292929"
            color="basil"
            id="policy-tab-header"
            centered
            grow
        >
            <v-tab>Contact Info</v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab" class="policy-tab-content-container">
            <v-tab-item>
                <v-card flat class="policy-tab-content-container">
                    <v-card-text>

                        <p><b><v-icon>mdi-twitter</v-icon> <a v-bind:href="'https://twitter.com/options_fam'">Twitter</a></b></p>

                        <p><b><v-icon>mdi-facebook</v-icon> <a v-bind:href="'https://www.facebook.com/Optionsfambot-104447791162400/'">Facebook</a></b></p>

                        <p><b><v-icon>mdi-email</v-icon> <a v-bind:href="'mailto:admin@optionsfambot.com'">Email Us</a></b></p>

                    </v-card-text>
                </v-card>
            </v-tab-item>

        </v-tabs-items>
    </div>
</template>


<script>
    export default {
        name: 'Contact',

        props: {
        },

        mounted() {
        },

        components: {
        },

        methods: {
        },

        data: () => ({
            tab: ""
        }),
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    #policy-container {
        height: auto;
        width: 100%;
        background-color: #292929;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    #policy-tab-header {
        width: 100%;
    }

    .policy-tab-content-container {
        width: 100%;
        height: 100%;
        background-color: #292929;
    }

    @media screen and (min-width: 750px) {
        #policy-container {
            width: 50%;
            max-width: 1000px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            margin: auto;
        }
    }
</style>